import { useEffect } from 'react';

export const useStructuredData = (schema) => {
  useEffect(() => {
    if (!schema) return;

    // Remove existing structured data for this type
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => {
      if (script.textContent.includes(schema['@type'])) {
        script.remove();
      }
    });

    // Create and add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [schema]);
};

export default useStructuredData;
